<template>
  <div>
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12" 
              sm="9"
            >
              Gestionar Competencias 
            </v-col>

            <template v-if="competenciasWorldSkillsNacional.length > 0">
              <v-col 
                cols="12" 
                sm="3"
              >
                <v-text-field 
                  outlined 
                  dense 
                  hide-details
                  append-icon="mdi-magnify" 
                  label="Buscar Competencia" 
                  v-model="searchTable"
                >
                </v-text-field>
              </v-col>
            </template>
          </v-row>
        </v-card-title>
        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="competenciasWorldSkillsNacional"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip 
              v-for="accion in accionesModulo"
              :key="accion.id_modulo"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="ejecutarAcciones(accion.accion, item.id)"
                >
                  {{ accion.icono }}
                </v-icon>
              </template>
              <span>{{ accion.modulo }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,
    
    headersTable: [
      {
        text: "Competencia",
        value: "competencia",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Fecha de Inicio",
        value: "fecha_inicio",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Fecha de Finalización",
        value: "fecha_fin",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      }
    ]
  }),
  
  mounted() {
    this.$store.dispatch("gestionarCompetenciasWorldSkills")

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    competenciasWorldSkillsNacional() {
      return this.$store.getters.obtenerCompetenciasWorldSkills.filter(competencia => competencia.tipo_competencia_id == 2).slice(0, 1);
    },

    usuario() {
      return this.$store.getters.usuario
    },

    accionesModulo() {
      const modulo = this.$store.getters.obtenerAccionesModulo.find(modulo => modulo.id_modulo == 70)
      const acciones = modulo.hijos.filter(modulo => modulo.accion !== null)
      return acciones;
    }
  },

  methods: {
    ejecutarAcciones(accion, id) {
      this[accion](id)
    },

    detalles(competencia) {
      this.$router.push({
        name: "competenciaws-detalles",
        params: { id_competencia: competencia }
      });
    },

    actualizar(competencia) {
      this.$router.push({
        name: "competenciaws-actualizar",
        params: { id_competencia: competencia }
      });
    },

    gestionarDocumentos(competencia) {
      this.$router.push({
        name: "competenciaws-documentos",
        params: { id_competencia: competencia }
      })
    },

    gestionarSedes(competencia) {
      this.$router.push({
        name: "asignar-sede",
        params: { id_competencia: competencia }
      });
    },

    gestionarFases(competencia) {
      this.$router.push({
        name: "competenciaws-fases",
        params: { id_competencia: competencia }
      });
    },

    asociarHabilidades(competencia) {
      this.$router.push({
        name: "asignar-habilidad",
        params: { id_competencia: competencia }
      });
    },

    gestionarAcompanantes(competencia) {
      this.$router.push({
        name: "gestionar-acompanante",
        params: { id_competencia: competencia }
      })
    },
  }
};
</script>
